import JotformPage from "@components/Jotform/JotformPage";
import Loading from "@components/layout/Loading";
import getFormId from "@utils/forms";
import { useCurrentUserMutation } from "@utils/hooks";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type FactFindProps = {};

const FactFindFinancialDetails: React.FC<FactFindProps> = () => {
  const navigate = useNavigate();

  const { mutate, isLoading, isSuccess } = useCurrentUserMutation();

  useEffect(() => {
    if (!isLoading && isSuccess) {
      navigate("/fact-find");
    }
  }, [isSuccess, isLoading, navigate]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <JotformPage
      formId={getFormId("fact_find_financial_details")}
      onSubmit={() => {
        mutate({
          form_fact_find_financial_details: true,
        });
      }}
    />
  );
};
export default FactFindFinancialDetails;